
// const colourOptions = [
//     ['#FFE242', '#F4BF5B', '#FF991A', '#EC8484', '#E17C43', '#E55555', '#BD4141', '#9A2C2C'],
//     ['#968EFF', '#46A9F8', '#38C5AB', '#7DD268', '#FFE242', '#FABE4D', '#FF991A', '#EC8484', '#FFBDBD', '#E55555'],
//     ];

// const random = Math.floor(Math.random() * colourOptions.length);
// export const COLORS = colourOptions[random];

export const COLORS = ['#968EFF', '#46A9F8', '#38C5AB', '#7DD268', '#FFE242', '#FABE4D', '#FF991A', '#EC8484', '#FFBDBD', '#E55555'];